// extracted by mini-css-extract-plugin
export default {"card":"card-module__card--HTuKs","cardFooter":"card-module__cardFooter--konMf"};